import React from 'react'
import { Link } from 'react-router-dom'
import PageTitle from './PageTitle'

const PREVIEW_HTML = `${process.env.PUBLIC_URL}/preview/stitch-redesign.html`
const DESIGN_MD = `${process.env.PUBLIC_URL}/preview/DESIGN.md`

const StitchRedesignPreview = () => {
  return (
    <>
      <PageTitle title="Colozoo — Website redesign preview" />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          width: '100%',
          overflow: 'hidden',
          background: '#0f1d23',
        }}
      >
        <div
          style={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            padding: '8px 16px',
            background: '#243238',
            color: '#e4f3fb',
            fontSize: 13,
            lineHeight: 1.4,
            borderBottom: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          <span>
            <strong style={{ color: '#ffb3ac' }}>Internal preview</strong>
            {' — '}
            Stitch mockup (not the live site). Share this URL with your team.
          </span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
            <a
              href={DESIGN_MD}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#8af4f3', textDecoration: 'none', whiteSpace: 'nowrap' }}
            >
              Design notes (DESIGN.md)
            </a>
            <Link
              to="/"
              style={{ color: '#fff', textDecoration: 'none', whiteSpace: 'nowrap' }}
            >
              Back to live site
            </Link>
          </div>
        </div>
        <iframe
          title="Colozoo website redesign preview"
          src={PREVIEW_HTML}
          style={{
            flex: 1,
            width: '100%',
            border: 'none',
            background: '#f3faff',
          }}
        />
      </div>
    </>
  )
}

export default StitchRedesignPreview
